module.exports = __webpack_public_path__ + "img/media-dark-icon.2acf9661.svg";